import { useEffect, useState } from 'react';
import adminService from '../../../../services/adminService';
import './AdminCorporateContracts.scss';

export default function CorporateContracts() {
    const [showNewContract, setShowNewContract] = useState(false);
    const [selectedContractId, setSelectedContractId] = useState(null);
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchContracts();
    }, []);

    async function fetchContracts() {
        setLoading(true);
        try {
            const data = await adminService.getCorporateContracts();
            setContracts(data);
        } catch (err) {
            console.error('Erro ao buscar contratos:', err);
        } finally {
            setLoading(false);
        }
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };
    
    if (showNewContract) {
        return <NewCorporateContract onBack={() => { setShowNewContract(false); fetchContracts(); }} />;
    }

    if (selectedContractId) {
        return (
            <ContractDetail
                contractId={selectedContractId}
                onBack={() => { setSelectedContractId(null); fetchContracts(); }}
            />
        );
    }


    return (
        <div className="corporate-contracts">

            <div className="corporate-contracts__header">

                <div>
                    <h1>Contratos Empresariais</h1>

                    <p>
                        Gerencie os planos personalizados negociados com as empresas.
                    </p>
                </div>

                <button
                    className="corporate-contracts__new-button"
                    onClick={() => setShowNewContract(true)}
                >
                    <span>+</span>
                    Novo contrato
                </button>

            </div>


            <div className="corporate-contracts__stats">

                <div className="corporate-stat-card">
                    <span className="corporate-stat-card__label">
                        Contratos ativos
                    </span>

                    <strong>
                        {contracts.filter(
                            contract => contract.status === 'Ativo'
                        ).length}
                    </strong>
                </div>


                <div className="corporate-stat-card">
                    <span className="corporate-stat-card__label">
                        Empresas contratadas
                    </span>

                    <strong>
                        {contracts.length}
                    </strong>
                </div>


                <div className="corporate-stat-card">
                    <span className="corporate-stat-card__label">
                        Receita mensal contratada
                    </span>

                    <strong>
                        {formatCurrency(
                            contracts
                                .filter(
                                    contract => contract.status === 'Ativo'
                                )
                                .reduce(
                                    (total, contract) =>
                                        total + contract.monthlyValue,
                                    0
                                )
                        )}
                    </strong>
                </div>

            </div>


            <div className="corporate-contracts__table-container">

                <div className="corporate-contracts__table-header">

                    <div>
                        <h2>Contratos cadastrados</h2>

                        <span>
                            {contracts.length} contratos encontrados
                        </span>
                    </div>

                </div>


                <div className="corporate-contracts__table-wrapper">

                    <table className="corporate-contracts__table">

                        <thead>
                            <tr>
                                <th>Empresa</th>
                                <th>Plano</th>
                                <th>Valor mensal</th>
                                <th>Dia da cobrança</th>
                                <th>Próxima cobrança</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>


                        <tbody>

                            {contracts.map((contract) => (

                                <tr key={contract.id}>

                                    <td>
                                        <div className="company-cell">
                                            <div className="company-cell__avatar">
                                                {contract.companyName
                                                    .charAt(0)
                                                    .toUpperCase()}
                                            </div>

                                            <span>
                                                {contract.companyName}
                                            </span>
                                        </div>
                                    </td>


                                    <td>
                                        <span className="plan-name">
                                            {contract.contractName}
                                        </span>
                                    </td>


                                    <td>
                                        <strong>
                                            {formatCurrency(contract.monthlyValue)}
                                        </strong>
                                    </td>


                                    <td>
                                        Todo dia {contract.billingDay}
                                    </td>


                                    <td>
                                        {contract.nextBillingDate}
                                    </td>


                                    <td>

                                        <span
                                            className={`status-badge status-badge--${contract.status.toLowerCase()}`}
                                        >
                                            <span className="status-badge__dot" />

                                            {contract.status}
                                        </span>

                                    </td>


                                    <td>

                                        <button
                                            className="table-action-button"
                                            title="Ver detalhes"
                                            onClick={() => setSelectedContractId(contract.id)}
                                        >
                                            Ver detalhes
                                        </button>
                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>
    );
}


function NewCorporateContract({ onBack }) {
    const [formData, setFormData] = useState({
        companyId: '',
        contractName: '',
        responsible: '',
        whatsapp: '',
        monthlyValue: '',
        freelancersPerMonth: '',
        billingDay: '',
        nextBilling: '',
        automaticWalletCharge: true,
        chargeHiringFee: false,
        feePercentage: 0,
        jobPriorityEnabled: true,
        punishmentAnalysisEnabled: true,
        status: 'Ativo',
        observations: ''
    });
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        async function fetchCompanies() {
            try {
                const data = await adminService.getCorporateContractCompanies();
                setCompanies(data);
            } catch (err) {
                console.error('Erro ao buscar empresas:', err);
            }
        }

        fetchCompanies();
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            await adminService.createCorporateContract({
                companyUserId: formData.companyId,
                contractName: formData.contractName,
                responsible: formData.responsible,
                whatsapp: formData.whatsapp,
                monthlyValue: parseFloat(formData.monthlyValue),
                freelancersPerMonth: formData.freelancersPerMonth
                    ? parseInt(formData.freelancersPerMonth)
                    : null,
                billingDay: parseInt(formData.billingDay),
                firstBillingDate: formData.nextBilling,
                observations: formData.observations,
                feePercentage: formData.chargeHiringFee
                    ? parseFloat(formData.feePercentage) || 0
                    : 0,
                jobPriorityEnabled: formData.jobPriorityEnabled,
                punishmentAnalysisEnabled: formData.punishmentAnalysisEnabled,
            });

            onBack();
        } catch (err) {
            console.error('Erro ao criar contrato:', err);
        }
    };


    return (
        <div className="corporate-contract-form">

            <div className="corporate-contract-form__top">

                <button
                    type="button"
                    className="back-button"
                    onClick={onBack}
                >
                    ← Voltar
                </button>

            </div>


            <div className="corporate-contract-form__header">

                <div>
                    <span className="section-label">
                        CONTRATOS EMPRESARIAIS
                    </span>

                    <h1>
                        Novo contrato empresarial
                    </h1>

                    <p>
                        Cadastre as condições comerciais negociadas com a empresa.
                    </p>
                </div>

            </div>


            <form onSubmit={handleSubmit}>


                {/* EMPRESA */}

                <section className="form-section">

                    <div className="form-section__header">

                        <div className="form-section__number">
                            01
                        </div>

                        <div>
                            <h2>Dados da empresa</h2>

                            <p>
                                Selecione a empresa que terá este contrato.
                            </p>
                        </div>

                    </div>


                    <div className="form-grid">

                        <div className="form-group form-group--full">

                            <label>
                                Empresa *
                            </label>

                            <select
                                name="companyId"
                                value={formData.companyId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">
                                    Selecione uma empresa
                                </option>

                                {companies.map((company) => (
                                    <option key={company.id} value={company.id}>
                                        {company.name}
                                    </option>
                                ))}
                            </select>

                        </div>


                        <div className="form-group">

                            <label>
                                Responsável pelo contrato
                            </label>

                            <input
                                type="text"
                                name="responsible"
                                value={formData.responsible}
                                onChange={handleChange}
                                placeholder="Nome do responsável"
                            />

                        </div>


                        <div className="form-group">

                            <label>
                                WhatsApp
                            </label>

                            <input
                                type="text"
                                name="whatsapp"
                                value={formData.whatsapp}
                                onChange={handleChange}
                                placeholder="(35) 99999-9999"
                            />

                        </div>

                    </div>

                </section>



                {/* CONFIGURAÇÃO COMERCIAL */}

                <section className="form-section">

                    <div className="form-section__header">

                        <div className="form-section__number">
                            02
                        </div>

                        <div>
                            <h2>Configuração comercial</h2>

                            <p>
                                Defina as condições negociadas com a empresa.
                            </p>
                        </div>

                    </div>


                    <div className="form-grid">

                        <div className="form-group">

                            <label>
                                Nome do plano / contrato *
                            </label>

                            <input
                                type="text"
                                name="contractName"
                                value={formData.contractName}
                                onChange={handleChange}
                                placeholder="Ex: Plano Corporativo"
                                required
                            />

                        </div>


                        <div className="form-group">

                            <label>
                                Valor mensal *
                            </label>

                            <div className="input-money">

                                <span>
                                    R$
                                </span>

                                <input
                                    type="number"
                                    name="monthlyValue"
                                    value={formData.monthlyValue}
                                    onChange={handleChange}
                                    placeholder="500,00"
                                    min="0"
                                    step="0.01"
                                    required
                                />

                            </div>

                        </div>


                        <div className="form-group">

                            <label>
                                Freelancers estimados por mês
                            </label>

                            <input
                                type="number"
                                name="freelancersPerMonth"
                                value={formData.freelancersPerMonth}
                                onChange={handleChange}
                                placeholder="Ex: 20"
                                min="0"
                            />

                        </div>


                        <div className="form-group">
                            <label>
                                Cobrança por contratação
                            </label>

                            <label className="fee-toggle-option">
                                <input
                                    type="checkbox"
                                    name="chargeHiringFee"
                                    checked={formData.chargeHiringFee}
                                    onChange={(e) => {
                                        const checked = e.target.checked;

                                        setFormData(prev => ({
                                            ...prev,
                                            chargeHiringFee: checked,
                                            feePercentage: checked
                                                ? (prev.feePercentage || 10)
                                                : 0
                                        }));
                                    }}
                                />

                                <div>
                                    <strong>
                                        Cobrar taxa de contratação por freelancer?
                                    </strong>

                                    <span>
                                        {formData.chargeHiringFee
                                            ? 'A empresa pagará uma porcentagem sobre cada contratação.'
                                            : 'Nenhuma taxa será cobrada sobre as contratações.'
                                        }
                                    </span>
                                </div>
                            </label>

                            <div className="fee-percentage-wrapper">
                                <label>
                                    Porcentagem da taxa
                                </label>

                                <div className="input-money">
                                    <span>%</span>

                                    <input
                                        type="number"
                                        name="feePercentage"
                                        value={formData.feePercentage}
                                        onChange={handleChange}
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        disabled={!formData.chargeHiringFee}
                                        placeholder="Ex: 10"
                                    />
                                </div>

                                <small>
                                    {formData.chargeHiringFee
                                        ? 'Informe a porcentagem negociada com a empresa.'
                                        : 'Ative a cobrança acima para definir uma porcentagem.'
                                    }
                                </small>
                            </div>
                        </div>
                    </div>


                    <div className="benefits-grid">
                        <label className="benefit-option">
                            <input
                                type="checkbox"
                                name="jobPriorityEnabled"
                                checked={formData.jobPriorityEnabled}
                                onChange={handleChange}
                            />
                            <div>
                                <strong>🚀 Prioridade de vagas</strong>
                                <span>Vagas recebem maior destaque.</span>
                            </div>
                        </label>

                        <label className="benefit-option">
                            <input
                                type="checkbox"
                                name="punishmentAnalysisEnabled"
                                checked={formData.punishmentAnalysisEnabled}
                                onChange={handleChange}
                            />
                            <div>
                                <strong>🛡️ Análise de punições</strong>
                                <span>Suporte para análise de situações.</span>
                            </div>
                        </label>
                    </div>

                </section>



                {/* COBRANÇA */}

                <section className="form-section">

                    <div className="form-section__header">

                        <div className="form-section__number">
                            03
                        </div>

                        <div>
                            <h2>Configuração da cobrança</h2>

                            <p>
                                Defina quando e como o contrato será cobrado.
                            </p>
                        </div>

                    </div>


                    <div className="form-grid">

                        <div className="form-group">

                            <label>
                                Forma de cobrança
                            </label>

                            <select>
                                <option>
                                    Mensal
                                </option>

                                <option>
                                    Quinzenal
                                </option>

                                <option>
                                    Personalizada
                                </option>
                            </select>

                        </div>


                        <div className="form-group">

                            <label>
                                Dia da cobrança *
                            </label>

                            <select
                                name="billingDay"
                                value={formData.billingDay}
                                onChange={handleChange}
                                required
                            >
                                <option value="">
                                    Selecione o dia
                                </option>

                                {Array.from(
                                    { length: 28 },
                                    (_, index) => (
                                        <option
                                            key={index + 1}
                                            value={index + 1}
                                        >
                                            Dia {index + 1}
                                        </option>
                                    )
                                )}

                            </select>

                        </div>


                        <div className="form-group">

                            <label>
                                Próxima cobrança *
                            </label>

                            <input
                                type="date"
                                name="nextBilling"
                                value={formData.nextBilling}
                                onChange={handleChange}
                                required
                            />

                        </div>

                    </div>


                    <label className="automatic-charge">

                        <input
                            type="checkbox"
                            name="automaticWalletCharge"
                            checked={formData.automaticWalletCharge}
                            onChange={handleChange}
                        />

                        <div>

                            <strong>
                                Desconto automático da carteira
                            </strong>

                            <span>
                                O valor do contrato será descontado automaticamente
                                do saldo disponível da empresa.
                            </span>

                        </div>

                    </label>

                </section>



                {/* STATUS */}

                <section className="form-section">

                    <div className="form-section__header">

                        <div className="form-section__number">
                            04
                        </div>

                        <div>
                            <h2>Ativação do contrato</h2>

                            <p>
                                Defina o status inicial deste contrato.
                            </p>
                        </div>

                    </div>


                    <div className="form-group">

                        <label>
                            Status
                        </label>

                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <option value="Ativo">
                                Ativo
                            </option>

                            <option value="Pendente">
                                Pendente
                            </option>

                            <option value="Suspenso">
                                Suspenso
                            </option>
                        </select>

                    </div>


                    <div className="form-group form-group--full">

                        <label>
                            Observações
                        </label>

                        <textarea
                            name="observations"
                            value={formData.observations}
                            onChange={handleChange}
                            placeholder="Adicione informações importantes sobre o contrato..."
                            rows="5"
                        />

                    </div>

                </section>



                {/* ACTIONS */}

                <div className="corporate-contract-form__actions">

                    <button
                        type="button"
                        className="cancel-button"
                        onClick={onBack}
                    >
                        Cancelar
                    </button>


                    <button
                        type="submit"
                        className="save-button"
                    >
                        Criar contrato
                    </button>

                </div>

            </form>

        </div>
    );
}

function ContractDetail({ contractId, onBack }) {
    const [formData, setFormData] = useState(null);
    const [companyName, setCompanyName] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        async function fetchContract() {
            try {
                const data = await adminService.getCorporateContractById(contractId);
                setCompanyName(data.companyName);
                setStatus(data.status);
                setFormData({
                    contractName: data.contractName,
                    responsible: data.responsible ?? '',
                    whatsapp: data.whatsapp ?? '',
                    monthlyValue: data.monthlyValue,
                    freelancersPerMonth: data.freelancersPerMonth ?? '',
                    billingDay: data.billingDay,
                    nextBilling: data.nextBillingDate.slice(0, 10),

                    chargeHiringFee: Number(data.feePercentage) > 0,
                    feePercentage: Number(data.feePercentage) || 0,

                    jobPriorityEnabled: data.jobPriorityEnabled,
                    punishmentAnalysisEnabled: data.punishmentAnalysisEnabled,
                    observations: data.observations ?? ''
                });
            } catch (err) {
                console.error('Erro ao buscar contrato:', err);
            } finally {
                setLoading(false);
            }
        }
        fetchContract();
    }, [contractId]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSave = async (event) => {
        event.preventDefault();
        setSaving(true);

        try {
            await adminService.updateCorporateContract(contractId, {
                contractName: formData.contractName,
                responsible: formData.responsible,
                whatsapp: formData.whatsapp,
                monthlyValue: parseFloat(formData.monthlyValue),
                freelancersPerMonth: formData.freelancersPerMonth
                    ? parseInt(formData.freelancersPerMonth)
                    : null,
                billingDay: parseInt(formData.billingDay),
                nextBillingDate: formData.nextBilling,
                observations: formData.observations,
                feePercentage: formData.chargeHiringFee
                    ? parseFloat(formData.feePercentage) || 0
                    : 0,
                jobPriorityEnabled: formData.jobPriorityEnabled,
                punishmentAnalysisEnabled: formData.punishmentAnalysisEnabled,
            });

            onBack();
        } catch (err) {
            console.error('Erro ao salvar contrato:', err);
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm(`Suspender o contrato "${formData.contractName}"? A empresa perde os benefícios e para de ser cobrada automaticamente.`)) {
            return;
        }

        try {
            await adminService.deleteCorporateContract(contractId);
            onBack();
        } catch (err) {
            console.error('Erro ao suspender contrato:', err);
        }
    };

    if (loading || !formData) {
        return (
            <div className="corporate-contract-form">
                <div className="corporate-contract-form__top">
                    <button type="button" className="back-button" onClick={onBack}>← Voltar</button>
                </div>
                <p>Carregando...</p>
            </div>
        );
    }

    return (
        <div className="corporate-contract-form">
            <div className="corporate-contract-form__top">
                <button type="button" className="back-button" onClick={onBack}>← Voltar</button>
            </div>

            <div className="corporate-contract-form__header">
                <div>
                    <span className="section-label">CONTRATOS EMPRESARIAIS</span>
                    <h1>{companyName}</h1>
                    <p>Status atual: <strong>{status}</strong></p>
                </div>
            </div>

            <form onSubmit={handleSave}>
                <section className="form-section">
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Nome do plano / contrato *</label>
                            <input type="text" name="contractName" value={formData.contractName} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label>Valor mensal *</label>
                            <div className="input-money">
                                <span>R$</span>
                                <input type="number" name="monthlyValue" value={formData.monthlyValue} onChange={handleChange} min="0" step="0.01" required />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Freelancers estimados por mês</label>
                            <input type="number" name="freelancersPerMonth" value={formData.freelancersPerMonth} onChange={handleChange} min="0" />
                        </div>

                        <div className="form-group">

                            <label>
                                Cobrança por contratação
                            </label>

                            <label className="fee-toggle-option">

                                <input
                                    type="checkbox"
                                    name="chargeHiringFee"
                                    checked={formData.chargeHiringFee}
                                    onChange={(e) => {
                                        const checked = e.target.checked;

                                        setFormData(prev => ({
                                            ...prev,
                                            chargeHiringFee: checked,
                                            feePercentage: checked
                                                ? (prev.feePercentage || 10)
                                                : 0
                                        }));
                                    }}
                                />

                                <div>
                                    <strong>
                                        Cobrar taxa de contratação por freelancer?
                                    </strong>

                                    <span>
                                        {formData.chargeHiringFee
                                            ? 'A empresa pagará uma porcentagem sobre cada contratação.'
                                            : 'Nenhuma taxa será cobrada sobre as contratações.'
                                        }
                                    </span>
                                </div>

                            </label>

                            <div className="fee-percentage-wrapper">

                                <label>
                                    Porcentagem da taxa
                                </label>

                                <div className="input-money">

                                    <span>%</span>

                                    <input
                                        type="number"
                                        name="feePercentage"
                                        value={formData.feePercentage}
                                        onChange={handleChange}
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        disabled={!formData.chargeHiringFee}
                                    />

                                </div>

                            </div>

                        </div>

                        <div className="form-group">
                            <label>Dia da cobrança *</label>
                            <select name="billingDay" value={formData.billingDay} onChange={handleChange} required>
                                {Array.from({ length: 28 }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>Dia {i + 1}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Próxima cobrança *</label>
                            <input type="date" name="nextBilling" value={formData.nextBilling} onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="benefits-grid">
                        <label className="benefit-option">
                            <input type="checkbox" name="jobPriorityEnabled" checked={formData.jobPriorityEnabled} onChange={handleChange} />
                            <div><strong>🚀 Prioridade de vagas</strong></div>
                        </label>

                        <label className="benefit-option">
                            <input type="checkbox" name="punishmentAnalysisEnabled" checked={formData.punishmentAnalysisEnabled} onChange={handleChange} />
                            <div><strong>🛡️ Análise de punições</strong></div>
                        </label>
                    </div>

                    <div className="form-group form-group--full">
                        <label>Observações</label>
                        <textarea name="observations" value={formData.observations} onChange={handleChange} rows="4" />
                    </div>
                </section>

                <div className="corporate-contract-form__actions">
                    <button type="button" className="cancel-button" onClick={handleDelete} style={{ color: '#dc2626' }}>
                        Suspender contrato
                    </button>

                    <button type="submit" className="save-button" disabled={saving}>
                        {saving ? 'Salvando...' : 'Salvar alterações'}
                    </button>
                </div>
            </form>
        </div>
    );
}